export default function validationFiltre(filtre, errors) {
  if (filtre.dateComptable.dateFin && filtre.dateComptable.dateDebut
    && filtre.dateComptable.dateDebut > filtre.dateComptable.dateFin) {
    errors.push({
      message: 'listeJournalEcriture.filtre.error.dateFin',
    });
  }
}
